var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3796_1214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41016 10.5C5.80798 10.5 6.18951 10.342 6.47082 10.0607C6.75212 9.77936 6.91016 9.39782 6.91016 9C6.91016 8.60218 6.75212 8.22064 6.47082 7.93934C6.18951 7.65804 5.80798 7.5 5.41016 7.5C5.01233 7.5 4.6308 7.65804 4.3495 7.93934C4.06819 8.22064 3.91016 8.60218 3.91016 9C3.91016 9.39782 4.06819 9.77936 4.3495 10.0607C4.6308 10.342 5.01233 10.5 5.41016 10.5ZM10.6602 9C10.6602 9.39782 10.5021 9.77936 10.2208 10.0607C9.93951 10.342 9.55798 10.5 9.16016 10.5C8.76233 10.5 8.3808 10.342 8.0995 10.0607C7.81819 9.77936 7.66016 9.39782 7.66016 9C7.66016 8.60218 7.81819 8.22064 8.0995 7.93934C8.3808 7.65804 8.76233 7.5 9.16016 7.5C9.55798 7.5 9.93951 7.65804 10.2208 7.93934C10.5021 8.22064 10.6602 8.60218 10.6602 9ZM12.9102 10.5C13.308 10.5 13.6895 10.342 13.9708 10.0607C14.2521 9.77936 14.4102 9.39782 14.4102 9C14.4102 8.60218 14.2521 8.22064 13.9708 7.93934C13.6895 7.65804 13.308 7.5 12.9102 7.5C12.5123 7.5 12.1308 7.65804 11.8495 7.93934C11.5682 8.22064 11.4102 8.60218 11.4102 9C11.4102 9.39782 11.5682 9.77936 11.8495 10.0607C12.1308 10.342 12.5123 10.5 12.9102 10.5Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1602 9C18.1602 13.9703 14.1304 18 9.16016 18C4.18991 18 0.160156 13.9703 0.160156 9C0.160156 4.02975 4.18991 0 9.16016 0C14.1304 0 18.1602 4.02975 18.1602 9ZM16.6602 9C16.6602 13.1423 13.3024 16.5 9.16016 16.5C5.01791 16.5 1.66016 13.1423 1.66016 9C1.66016 4.85775 5.01791 1.5 9.16016 1.5C13.3024 1.5 16.6602 4.85775 16.6602 9Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3796_1214"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.160156,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.5213b6fbbd61178cbe9a9c5afe233609.svg";
export { ForwardRef as ReactComponent };